import api from '@/js/services/api';

export default {

    getLoggedUser() {
        return api().get(`/auth-user/get`)
    },
    updateAccountSettings(info) {
        return api().post(`/user/update`, info)
    },

    getCurrencyList() {
        return api().get(`/currencies/get`)
    },

    getCompanies() {
        return api().get(`/companies/get`)
    },

    getRegionsList() {
        return api().get(`/regions/get`)
    },

    getListOfStatuses() {
        return api().get(`/artist/statuses/get`)
    },

    getListOfClientStatuses() {
        return api().get(`/client/statuses/get`)
    }


}
